// extracted by mini-css-extract-plugin
export default {"tab":"ViewToggleTabs_tab__psfkB","active":"ViewToggleTabs_active__5fd9W"};